import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { API } from "@/lib/api";
import { homeFor, isOperator } from "@/lib/roles";
import { Button } from "./ui/button";
export default function OperatorRoute({ children, onboardingRole }) {
  const { user, session, loading } = useAuth();
  const location = useLocation();
  const [status, setStatus] = useState(null);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    if (!isOperator(user)) return;
    const controller = new AbortController();
    setStatus(null);
    setError("");
    axios
      .get(`${API}/onboarding/status`, {
        headers: { Authorization: `Bearer ${session?.access_token}` },
        signal: controller.signal,
      })
      .then((res) => {
        if (!controller.signal.aborted) setStatus(res.data);
      })
      .catch(() => {
        if (!controller.signal.aborted)
          setError("Unable to check your operator profile. Please retry.");
      });
    return () => controller.abort();
  }, [user?.id, user?.role, session?.access_token, retry]);
  if (loading)
    return (
      <div role="status" className="p-8">
        Loading your account…
      </div>
    );
  if (!user)
    return (
      <Navigate
        to={`/signin?returnTo=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  if (!isOperator(user)) return <Navigate to={homeFor(user)} replace />;
  if (error)
    return (
      <main className="max-w-lg mx-auto p-8" role="alert">
        <p>{error}</p>
        <Button className="mt-4" onClick={() => setRetry(retry + 1)}>
          Retry profile check
        </Button>
      </main>
    );
  if (!status)
    return (
      <div role="status" className="p-8">
        Checking your operator profile…
      </div>
    );
  if (onboardingRole) {
    return user.role === onboardingRole ? (
      children
    ) : (
      <Navigate to={`/onboarding/${user.role}`} replace />
    );
  }
  if (status.needs_onboarding)
    return <Navigate to={`/onboarding/${user.role}`} replace />;
  return children;
}
